import { render, staticRenderFns } from "./AddOrEditDialog.vue?vue&type=template&id=6445f94e&"
import script from "./AddOrEditDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports